<div *ngIf="isLoading" [ngClass]="{'loading': isLoading}">
    <img src="/assets/images/gear-spinner.svg">
</div>
<router-outlet></router-outlet>